module.exports = __webpack_public_path__ + "6f26a14680c5500c3817464e9a7ca1d1.svg";